module.exports = __webpack_public_path__ + "static/media/thumbs-down.762547b6.svg";